module.exports = __webpack_public_path__ + "static/media/fre-2.fd050b2a.jpg";